/* eslint-disable max-len */
import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {Link} from '../common/components';
import {Metadata} from '../common/metadata';

import {APIDocPage} from './page';
import {NavBar} from './components/NavBar';


export class UnityArGifSdkPage extends APIDocPage {
    pageInit() {
        super.pageInit();
        this.title = 'Unity AR GIF SDK - Better, Faster & Free | Get Your GIFs with Tenor';
    }
    renderPage() {
        return (
            <div className="UnityArGifSdkPage APIDocPage">
                <Metadata page={this}/>
                <NavBar pageLabelPrefix='api-unity'/>
                <div id="unity-ar">
                    <h1 className="mobile-only">The Tenor GIF SDK for Unity and ARKit</h1>
                    <video width="335" height="598" controls={true} preload="auto" muted={true} autoPlay={true}>
                        <source src="https://media.tenor.com/website/gifapi/TENOR-GIF-SDK-ARKIT-V002.mp4" type="video/mp4"/>
                    </video>
                    <div className="content">
                        <h1 className="non-mobile-only">The Tenor GIF SDK for Unity and ARKit</h1>
                        <p>Add GIFs to your AR application in a matter of minutes. Tenor search delivers the most relevant and engaging GIFs, letting you integrate GIFs in creative ways to inspire your users. Sample ideas include:</p>
                        <ul className="bullet-list">
                            <li>Display a GIF of a mood or favorite actor on a t-shirt</li>
                            <li>Include a GIF in a banner dragged by a plane </li>
                            <li>“Float” GIFs above someone’s head, or show one in
                  place of a computer screen</li>
                            <li>Let your imagination run wild...</li>
                        </ul>
                        <div className="buttons">
                            <Link
                                className="button"
                                to="https://github.com/Tenor-Inc/tenor-unity-ar-sdk">
                    Get Free SDK
                            </Link>
                            <Link
                                className="button"
                                to="https://github.com/Tenor-Inc/tenor-unity-ar-sdk-demo">
                    Get App Example
                            </Link>
                        </div>
                        <p>This SDK was built using the open and free <Link to='/gifapi' clickLabel='api-unity-homepage'>Tenor GIF API</Link>.</p>
                    </div>
                </div>
            </div>);
    }
}
